// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vv-icon[data-v-54ec208a]{width:32px}.custom-app-bar[data-v-54ec208a]{background:transparent!important}.custom-app-bar.v-app-bar--is-scrolled[data-v-54ec208a]{background:#f4f6f9!important}.custom-user-name[data-v-54ec208a]{font-weight:700}.custom-cursor[data-v-54ec208a]{cursor:pointer}.footer-card.v-card--flat.theme--light[data-v-54ec208a]{width:100%;background:#f4f6f9}", ""]);
// Exports
module.exports = exports;
